import { createAction, props } from '@ngrx/store';
import { Lobby } from '../../../shared/models/lobby';
import { LobbyServiceWithCategory } from '../../../shared/models/lobby-service';

export const loadLobbyDetailsSuccess = createAction(
    '[Lobby CheckIn API] Load Lobby Details Success',
    props<{lobby: Lobby[]}>()
);

export const loadLobbyDetailsFailure = createAction(
    '[Lobby CheckIn API] Load Lobby Details Fail',
    props<{error: string}>()
);

export const loadServicesSuccess = createAction(
    '[Lobby CheckIn API] Load Services Success',
    props<{services: LobbyServiceWithCategory[]}>()
);

export const loadServicesFailure = createAction(
    '[Lobby CheckIn API] Load Services Fail',
    props<{error: string}>()
);

export const addToLobbySuccess = createAction(
    '[Lobby CheckIn API] Add to Lobby Success',
    props<{lobbyEntryId: number}>()
);

export const addToLobbyFailure = createAction(
    '[Lobby CheckIn API] Add to Lobby Fail',
    props<{error: string}>()
);

export const instantAssistSuccess = createAction(
    '[Lobby CheckIn API] Instant Assist Success',
    props<{lobbyEntryId: number}>()
);
export const impersonateInstantAssistSuccess = createAction(
    '[Lobby CheckIn API] Impersonate Instant Assist Success',
    props<{lobbyEntryId: number,isImpersonateAssist:boolean,impersonateByName:string}>()
);

export const instantAssistFailure = createAction(
    '[Lobby CheckIn API] Instant Assist Fail',
    props<{error: string}>()
);
export const impersonateInstantAssistFailure = createAction(
    '[Lobby CheckIn API] Impersonate Instant Assist Fail',
    props<{error: string}>()
);